import { render } from "./SingleSlelect.vue?vue&type=template&id=3e7def51&scoped=true"
import script from "./SingleSlelect.vue?vue&type=script&lang=js"
export * from "./SingleSlelect.vue?vue&type=script&lang=js"

import "./SingleSlelect.vue?vue&type=style&index=0&id=3e7def51&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7def51"]])

export default __exports__